export const getSortedData = (items, sort) => {
  let data = items;

  if (sort) {
    if (sort.id !== 'life_time_value') {
      data = data.sort((a, b) =>
        !sort.desc ? a[sort.id]?.localeCompare(b[sort.id]) : b[sort.id]?.localeCompare(a[sort.id]),
      );
    } else {
      data = data.sort((a, b) => (!sort.desc ? a[sort.id] - b[sort.id] : b[sort.id] - a[sort.id]));
    }
  }
  return data;
};
